var _defs, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit-user-3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        stroke: #336;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .st0, .st2 {\n        stroke-width: 66.7px;\n      }\n\n      .st1 {\n        stroke-width: 66.7px;\n      }\n\n      .st2 {\n        stroke: #d47500;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    className: "st2",
    d: "M690.3,489.7l-46.7-46.7c-13-12.7-33.7-12.7-46.7,0l-163.7,163.7v93.3h93.3l163.7-163.7c12.7-13,12.7-33.7,0-46.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "primary",
    className: "st1",
    d: "M300,700c-148.3-12.3-200-66.7-200-66.7v-33.3c0-92,74.6-166.7,166.7-166.7h100"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "primary-2",
    className: "st0",
    cx: 366.7,
    cy: 266.7,
    r: 166.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.fac4c9fc7541313a314288fe75ee59a4.svg";
export { ForwardRef as ReactComponent };